import React from 'react';

const SpacerPreview = props => {
	const { from } = props;

	const fromButton = from === 'WidgetButton';
	return (
		<div className="WidgetPreviews">
			<div className={!from ? 'hover-wrap' : null}>
				{!from && <div className="hover-container">Spacer</div>}
				<div
					className="spacer-preview"
					style={{
						backgroundColor: fromButton ? 'white' : 'transparent',
						height: fromButton ? '60px' : '100px',
						width: '100%',
					}}
				></div>
			</div>
		</div>
	);
};

export default SpacerPreview;
